import { render, staticRenderFns } from "./Step3.vue?vue&type=template&id=02285570&"
import script from "./Step3.vue?vue&type=script&lang=js&"
export * from "./Step3.vue?vue&type=script&lang=js&"
import style0 from "./Step3.vue?vue&type=style&index=0&id=02285570&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports